import { Link } from 'react-router-dom';
import './SolutionsBanner.css';
import heroBg from '../../assets/sol_banner_house.png';

export default function SolutionsBanner() {
  return (
    <section className="sol-banner-section" style={{ backgroundImage: `url(${heroBg})` }}>
      <div className="sol-banner-inner">
        <div className="sol-banner-card">
          <h1 className="sol-banner-eyebrow">Household Solar Panels in Melbourne</h1>
          <h2 className="sol-banner-heading">Reduce Your Electricity Bills</h2>
          <p className="sol-banner-subtitle">with Solar + Battery</p>
          <div className="sol-banner-divider" />
          <p className="sol-banner-body">
            Helping Australian households reduce rising electricity costs and move closer to near-0 power bills.
          </p>
          <Link to="/contact" className="sol-banner-btn">
            Explore Solutions →
          </Link>
          <div className="sol-banner-save">
            <span>Most households save $3,000+ a year*</span>
          </div>
        </div>
      </div>
    </section>
  );
}
